import { createModel, RematchDispatch } from '@rematch/core';
import * as sceneAdminApi from '../../../services/admin/scene.service';
import SceneType from '../../../types/admin/scene.type';
import { PaginationResponseType } from '../../../types/CommonTypes';
import { RootModel } from '../../models';
import baseEntity from '../base.entity';

export const storeName = 'sceneAdminEntity';

export const sceneAdminEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof sceneAdminEntity>) => ({
    async load(params): Promise<PaginationResponseType<SceneType>> {
      try {
        const res = await sceneAdminApi.getAdminScenes(params);
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async loadById(id, state): Promise<SceneType> {
      try {
        const res = await sceneAdminApi.getAdminScene(id);
        const scene = res.data;
        if (scene) {
          this.saves([scene]);
        }
        return scene;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default sceneAdminEntity;
